<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <p>
              The once-off payment of R{{ onceOffPrice }} will <b>not</b> be
              charged as your first will is free. Your credit card is being
              added here for future annual payments of R{{ subscriptionPrice }}.
              R1 will be deducted now, to ensure your card is valid, but you
              will be refunded for the amount.
            </p>
            <PaymentForm
              payment-plan="SUBSCRIPTION"
              :tokenize-only="true"
              @payment-form-loaded="paymentFormLoaded = true"
            />

            <div v-show="!paymentFormLoaded" class="text-center">
              <v-progress-circular indeterminate color="primary" />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PaymentForm from './PaymentForm.vue';

  export default {
    name: 'RedeemFirstWillFreeSubscription',
    components: {
      PaymentForm,
    },
    data() {
      return {
        paymentFormLoaded: false,
      };
    },
    computed: {
      onceOffPrice() {
        return process.env.VUE_APP_ONCE_OFF_PRICE;
      },
      subscriptionPrice() {
        return process.env.VUE_APP_SUBSCRIPTION_PRICE;
      },
    },
    mounted() {
      this.customizePaymentFormSubmitLabel();
    },
    methods: {
      customizePaymentFormSubmitLabel() {
        var peachPaymentCustomization = document.createElement('script');
        peachPaymentCustomization.type = 'text/javascript';
        peachPaymentCustomization.text =
          'var wpwlOptions = {labels: {submit: "Redeem free will"}}';
        document.body.appendChild(peachPaymentCustomization);
      },
    },
  };
</script>
